<article class="metric-card" [class.good]="tone() === 'good'" [class.warn]="tone() === 'warn'" [class.danger]="tone() === 'danger'">
  <p class="metric-label">{{ label() }}</p>
  <div class="metric-value">{{ value() }}</div>
  @if (hint()) {
    <p class="metric-hint">{{ hint() }}</p>
  }
</article>
